import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { LocaSmartLayout } from "../../components/locasmart-layout";

// Animação de entrada suave
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Estilos usando styled-components
const FormContainer = styled.div`
  padding: 40px;
  margin: 20px;
  max-width: 600px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 0.5s ease-in-out;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const InputField = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #25d366;
    outline: none;
  }

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 0.9rem;
  }
`;

const TextAreaField = styled.textarea`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  min-height: 150px;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #25d366;
    outline: none;
  }

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 0.9rem;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #128c7e;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 0.9rem;
  }
`;

const FooterText = styled.p`
  text-align: center;
  color: #777;
  margin-top: 20px;
  font-size: 0.9rem;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

function ReportarProblemas() {
  const [titulo, setTitulo] = useState("");
  const [texto, setTexto] = useState("");

  const handleSubmit = () => {
    // Codifica o texto para ser usado em uma URL
    const mensagem = encodeURIComponent(`*Título:* ${titulo}\n\n*Descrição do Bug:* ${texto}`);
    const url = `https://api.whatsapp.com/send?phone=5585991491356&text=${mensagem}`;

    // Abre diretamente no WhatsApp (app ou web)
    window.location.href = url;
  };

  return (
    <LocaSmartLayout>
      <FormContainer>
        <Title>Reportar Problema</Title>
        <InputField
          type="text"
          placeholder="Título do problema"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
        />
        <TextAreaField
          placeholder="Descreva o problema detalhadamente..."
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
        <SubmitButton onClick={handleSubmit}>Enviar via WhatsApp</SubmitButton>
        <FooterText>
          Sua mensagem será enviada diretamente para nossa equipe de suporte.
        </FooterText>
      </FormContainer>
    </LocaSmartLayout>
  );
}

export default ReportarProblemas;